import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ENVIRONMENT } from '@cfp/core';
import { LayoutContainer } from '@cfp/shared/ui/layout-container';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cfp-building-public-shared-link-invalid-page',
  templateUrl: './building-public-shared-link-invalid-page.html',
  imports: [LayoutContainer, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildingPublicSharedLinkInvalidPage {
  private readonly environment = inject(ENVIRONMENT);

  protected backgroundUrl = this.environment.images.loginBackground
    ? `url(${this.environment.customerAssetsDir}img/${this.environment.images.loginBackground})`
    : undefined;
}
